import { createGlobalStyle } from 'styled-components'

export const AuroraInputSelectionStyles = createGlobalStyle<{
  selectionTextColor: string
  selectionBackgroundColor: string
}>`
  input::selection,
  textarea::selection {
    color: ${({ selectionTextColor }) => selectionTextColor};
    background-color: ${({ selectionBackgroundColor }) => selectionBackgroundColor};
  }
`
